import { CategoryItemConfig } from '~/api/items/_types';

export const useCategoryItemConfigStore = defineStore('category-item-config', () => {
    const activeConfig = ref<CategoryItemConfig | null>(null);

    const reset = () => {
        activeConfig.value = null;
    };

    return {
        activeConfig,
        reset,
    };
});
